export default __webpack_public_path__ + "static/media/logo.79d14449.png";